import React from 'react';
import styled from 'styled-components';

const StyledFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 1rem 0.75rem 1rem;
`;

const StyledLinks = styled.span`
  font-size: 0.8125rem;
  color: #57534e;
  font-weight: 400;

  a {
    color: #57534e;
    text-decoration: underline;
    text-underline-offset: 2px;
    padding: 0.1rem 0.15rem;
    border-radius: 0.2rem;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #f5f5f4;
      text-decoration: none;
    }

    &:focus-visible {
      outline: 2px solid #1249a1;
      outline-offset: 2px;
    }
  }
`;

export function FooterMeta() {
  return (
    <StyledFooter>
      <StyledLinks>
        <a
          href="https://opiniion.com/legal/terms-of-use/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms
        </a>
        {' & '}
        <a
          href="https://opiniion.com/legal/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy
        </a>
      </StyledLinks>
    </StyledFooter>
  );
}
